<template>
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height:1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">{{ breadCrumb }}</div>
        <div class="text-lg md:text-lg">Ökologie ({{ tab }})</div>
        <div class="grid grid-cols-8 justify-items-stretch items-center gap-y-3">
          <div class="col-span-2 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
            Frage
          </div>
          <div class="text-sm font-bold col-span-1" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
            Vorhanden
          </div>
          <div class="text-sm font-bold col-span-4" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
            Details
          </div>
          <div class="col-span-1 text-sm font-bold" style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;">
            Bewertung
          </div>
          <div class="text-xs col-span-2">Biotypkartierung</div>
          <div class="col-span-1 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'biotoptypkartierung')?.getSelectedAuswahlLabelsString() }}</div>
          <div class="col-span-4 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'biotoptypkartierung-details')?.['eingabeText'] }}</div>

          <bewertung-chip-mehrfach
            fragesPath="biotoptypkartierung-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Einzelbäume</div>
          <div class="col-span-1 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'einzelbaeume')?.getSelectedAuswahlLabelsString() }}</div>
          <div class="col-span-4 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'einzelbaeume-details')?.['eingabeText'] }}</div>

          <bewertung-chip-mehrfach
            fragesPath="einzelbaeume-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Archäologisches Denkmal</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'archaeologisches-denkmal')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="archaeologisches-denkmal-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">FFH Gebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'ffh-gebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="ffh-gebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Vogelschutzgebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'vogelschutzgebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="vogelschutzgebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Geotop</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'geotop')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="geotop-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Geschütztes Offenlandbiotop (§)</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'geschuetztes-offenlandbiotop')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="geschuetztes-offenlandbiotop-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Geschütztes Waldbiotop (§)</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'geschuetztes-waldbiotop')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="geschuetztes-waldbiotop-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Naturdenkmal Flächenhaft</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'naturdenkmal-flaechenhaft')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="naturdenkmal-flaechenhaft-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Naturdenkmal Einzelgebilde</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'naturdenkmal-einzelgebilde')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="naturdenkmal-einzelgebilde-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Überschwemmungsgebiet HQ100</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'ueberschwemmungsgebiet-hq100')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="ueberschwemmungsgebiet-hq100-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Überschwemmungsgebiet M1_M2</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'ueberschwemmungsgebiet-m1-m2')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="ueberschwemmungsgebiet-m1-m2-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Gewässernetz</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'gewaessernetz')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="gewaessernetz-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Wasserschutzgebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'wasserschutzgebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="wasserschutzgebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Heilquellenschutzgebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'heilquellenschutzgebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="heilquellenschutzgebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Landschaftsschutzgebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'landschaftsschutzgebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="landschaftsschutzgebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Waldschutzgebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'waldschutzgebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="waldschutzgebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Naturschutzgebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'naturschutzgebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="naturschutzgebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Biosphärengebiet</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'biosphaerengebiet')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="biosphaerengebiet-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Bodendenkmale</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'bodendenkmale')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="bodendenkmale-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          /> 
          <div class="text-xs col-span-2">Höhlenbäume</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'hoehlenbaeume')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="hoehlenbaeume-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          /> 
          <div class="text-xs col-span-2">Haselmausnester</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'haselmausnester')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="haselmausnester-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Reptilien</div>
          <div class="col-span-5 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'reptilien')?.getSelectedAuswahlLabelsString() }}</div>
          
          <bewertung-chip-mehrfach
            fragesPath="reptilien-bewertung"
            :fragenblock="oekologie"
            :ba="ba"
            :immobilie="immobilie"
            :lang="lang"
            class="justify-self-end"
          />
          <div class="text-xs col-span-2">Weitere Informationen</div>
          <div class="col-span-6 text-xs text-gray-500">{{ oekologie.findFrageByRelativePath(ba, 'oekologie-und-schutzgebiete-informationen')?.['eingabeText'] }}</div>
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page>

</template>
  
<script lang="ts">
  import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
  import TngHeader from './TngHeader.vue';
  import BeFooter from './BeFooter.vue';
  import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
  import Immobilie from '@/models/immobilie.model';
  import BewertungChipMehrfach from './BewertungChipMehrfach.vue';
  import PdfChip from '../../Components/PdfChip.vue';
  import { defineComponent, PropType, toRef } from 'vue';
  import { Fragenblock } from '@/models/ba/Fragenblock';
  
  export default defineComponent({
    name: 'OekologieBlock',
     components: {
      PdfA4Page,
      TngHeader,
      BeFooter,
      PdfChip,
      BewertungChipMehrfach,
    },
    props: {
      immobilie: {
        type: Object as PropType<Immobilie>,
        required: true,
      },
      breadCrumb: {
        type: String,
        default: "",
      },
      tab: {
        type: String,
        default: "",
      },
      ba: {
        type: Object as PropType<Bestandsaufnahme>,
        required: true,
      },
      oekologie: {
        type: Object as PropType<Fragenblock>,
        required: true,
      },
      lang: {
        type: String,
        default: 'de',
      },
    }
  });
  </script>

  <style scoped>
  * {
    color: rgb(23, 68, 81);
    font-family: var(--secondaryFont);
  }
  .pdf-content {
    width: 800px;
    margin: 0 auto;
    color: var(--white100);
  }
  .landingpage-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: black;
  }
  .trenner {
    height: 1px;
    border-width: 0;
    color: gray;
    background-color: gray;
  }
  .content {
    height: 870px;
  }
  div{
    margin-top: -2px;
  }
</style>